import {GdprFieldNames} from "../gdpr.consimtamant.types";

export class GDPRAnsw{
    txt: string;
    id: GdprFieldNames;
    inverted: boolean;
    hasL2: boolean;
}

export class GdprQ {
    title?: string;
    q: string;
    answsL1: GDPRAnsw[];
    answsL2: GDPRAnsw[];
}
export const gdprQuestions: GdprQ[] = [
    {
        title:"Declar prin prezenta că am citit și am luat la cunoștință conținutul Notei de informare privind prelucrarea datelor cu caracter personal adresată clienților {nume_cabinet}",
        q: "",
        answsL1: [
            { id: GdprFieldNames.GDPR_AGREE_SB_V1__info1_1, inverted: true, hasL2: false, txt: "{tick} NU "},
            { id: GdprFieldNames.GDPR_AGREE_SB_V1__info1_1, inverted:false, hasL2: false, txt: "{tick} DA"},
        ],
        answsL2:[],
    },

    {
        title: "Îmi exprim consimțământul expres, liber, neechivoc și specific cu privire la:",
        q: "1.\tPrimirea de informații privind produsele și serviciile medicale furnizate de {nume_cabinet}",
        answsL1: [
            { id: GdprFieldNames.GDPR_AGREE_SB_V1__info2_1, inverted: true, hasL2: false, txt: "{tick} NU"},
            { id: GdprFieldNames.GDPR_AGREE_SB_V1__info2_1, inverted:false, hasL2: true, txt: "{tick} DA"},
        ],
        answsL2:[
            { id: GdprFieldNames.GDPR_AGREE_SB_V1__info2_2, inverted: false, hasL2: false, txt: "\t{tick} sms"},
            { id: GdprFieldNames.GDPR_AGREE_SB_V1__info2_3, inverted: false, hasL2: false, txt: "\t{tick} email"},
            { id: GdprFieldNames.GDPR_AGREE_SB_V1__info2_4, inverted: false, hasL2: false, txt: "\t{tick} apel telefonic"},
            { id: GdprFieldNames.GDPR_AGREE_SB_V1__info2_5, inverted: false, hasL2: false, txt: "\t{tick} poștă"},
            { id: GdprFieldNames.GDPR_AGREE_SB_V1__info2_6, inverted: false, hasL2: false, txt: "\t{tick} platforme socializare"},
        ],
    },

    {
        q: "2.\tPrelucrarea de către {nume_cabinet}, în calitate de Operator, în scopuri de promovare și publicitate",
        answsL1: [
            { id: GdprFieldNames.GDPR_AGREE_SB_V1__info3_1, inverted: true, hasL2: false, txt: "{tick} NU"},
            { id: GdprFieldNames.GDPR_AGREE_SB_V1__info3_1, inverted:false, hasL2: true, txt: "{tick} DA"},
        ],
        answsL2:[
            { id: GdprFieldNames.GDPR_AGREE_SB_V1__info3_2, inverted: false, hasL2: false, txt: "\t{tick} vocea și/sau imaginea (capturate în fotografii sau în înregistrări video)"},
            { id: GdprFieldNames.GDPR_AGREE_SB_V1__info3_3, inverted: false, hasL2: false, txt: "\t{tick} mărturii, impresii, testimoniale"},
            { id: GdprFieldNames.GDPR_AGREE_SB_V1__info3_4, inverted: false, hasL2: false, txt: "\t{tick} detalii despre tratamentele efectuate"},
            { id: GdprFieldNames.GDPR_AGREE_SB_V1__info3_5, inverted: false, hasL2: false, txt: "\t{tick} nume și prenume"},

            { id: GdprFieldNames.GDPR_AGREE_SB_V1__info3_6, inverted: false, hasL2: false, txt: "\t{tick} postări pe rețelele sociale cu privire la serviciile care mi-au fost prestate în cadrul {nume_cabinet}"},
            { id: GdprFieldNames.GDPR_AGREE_SB_V1__info3_7, inverted: false, hasL2: false, txt: "\t{tick} materiale publicitare (broșuri, pliante)"},
            { id: GdprFieldNames.GDPR_AGREE_SB_V1__info3_8, inverted: false, hasL2: false, txt: "\t{tick} publicitate online și offline"},
            { id: GdprFieldNames.GDPR_AGREE_SB_V1__info3_9, inverted: false, hasL2: false, txt: "\t{tick} postarea pe website-ul clinicii"},
        ],
    },
];
